/** WAI-ARIA tabs for vet pricing — dynamic tab/panel ids from markup. */
(function () {
  'use strict';

  function initPricingTabs(root) {
    var wrap = root || document.getElementById('tabs-pricing');
    if (!wrap) return;
    var tablist = wrap.querySelector('[role="tablist"]');
    if (!tablist) return;
    var mobileSelect = wrap.querySelector('[data-pricing-jump]');
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    var order = tabs.map(function (t) {
      return t.id.replace(/^tab-/, '');
    });
    var panels = {};
    order.forEach(function (key) {
      var p = document.getElementById('panel-' + key);
      if (p) panels[key] = p;
    });

    function activate(key) {
      order.forEach(function (k) {
        if (panels[k]) panels[k].hidden = k !== key;
      });
      tabs.forEach(function (tab) {
        var id = tab.id.replace(/^tab-/, '');
        var is = id === key;
        tab.setAttribute('aria-selected', is ? 'true' : 'false');
        tab.tabIndex = is ? 0 : -1;
      });
      if (mobileSelect && mobileSelect.value !== key) {
        mobileSelect.value = key;
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.id.replace(/^tab-/, ''));
      });
      tab.addEventListener('keydown', function (e) {
        var id = tab.id.replace(/^tab-/, '');
        var i = order.indexOf(id);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          var ni = (i + 1) % order.length;
          document.getElementById('tab-' + order[ni]).focus();
          activate(order[ni]);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          var pi = (i - 1 + order.length) % order.length;
          document.getElementById('tab-' + order[pi]).focus();
          activate(order[pi]);
        }
      });
    });

    if (mobileSelect) {
      mobileSelect.addEventListener('change', function () {
        if (order.indexOf(mobileSelect.value) !== -1) {
          activate(mobileSelect.value);
        }
      });
    }

    var selectedTab = tabs.find(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    });
    var initialKey = selectedTab ? selectedTab.id.replace(/^tab-/, '') : order[0];
    activate(initialKey);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPricingTabs(document.getElementById('tabs-pricing'));
    });
  } else {
    initPricingTabs(document.getElementById('tabs-pricing'));
  }
})();
